<template>
    <div class="body">
        <el-tree :data="treeData"
                 :props="{children:'children', label:'name'}"
                 default-expand-all
        >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span>{{node.label}}
                        <span style="color:red">&nbsp&nbsp{{data.remark}}</span>&nbsp&nbsp----【{{data.typeCN}}】
                    </span>
                    <span v-if="data.children&&data.children.length>0">

                    </span>
                </span>
        </el-tree>
    </div>
</template>
<style lang="scss" rel="stylesheet/scss" scoped>
    .body {
        max-height: 500px;
        overflow-y: auto;
    }

</style>
<script type="text/ecmascript-6">

    import {Tree} from 'element-ui'
    import algorithmicTool from '../../../util/tools.js'

    export default {
        components: {
            'el-tree': Tree, algorithmicTool

        },
        props: {
            userId: null
        },
        data() {
            return {
                treeData: []
            };
        },
        mounted() {

        },
        methods: {
            init() {
                this.getDataList();
            },
            getDataList() {
                if (!this.userId) {
                    return
                }
                this.$http.get("/api/feature/getUserFeatruesByUserId?userId=" + this.userId).then((response) => {
                    let data = response.data;
                    if (data.success) {
                        let listdata = algorithmicTool.arrayToJsonTree(data.data, "id", "parentId");
                        this.treeData = listdata;
                    }
                })
            },
        },
        computed: {},

        filters: {}
    }
</script>



// WEBPACK FOOTER //
// src/modules/user/components/FeatureShow.vue